
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-library/[video]",
      function () {
        return require("private-next-pages/video-library/[video].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-library/[video]"])
      });
    }
  